import React, { useState, useEffect, useRef } from 'react';

import './css/sessionWatingRoom.scss';
import queryString from 'query-string';
import { ClearArray, getSessionDetail } from '../../Store/actions';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import useRedirect from '../../components/customHooks/useRedirect';

import BackdropComponent from '../../components/BackdropComponent';
import {
  log,
  Countdown as TimeCounter,
  setLocalStorage,
  getLocalStorage,
  timeDifference,
  openNewTab,
  generateTitle
} from '../../common/common';

import SessionWaitingTime from './component/SessionWaitingTime';

import { toast } from 'react-toastify';
import { pageTitles } from '../../common/pageTitles';
import { generateDataLayerGtm } from '../../helper/generateDataLayerGtm';
import { useTracker } from '../../TrackerFolder/TrackerComponent';
import { TrackerComponent } from '../../TrackerFolder';
import { BannerItem, BannerWorker } from '../../components/banner';
import appConfig from '../../config/config';
const pageName = pageTitles.session.waiting;
const url = appConfig.apiLoc;
let evtSource = '';
const SessionWaitingRoom = () => {
  const { redirectTo } = useRedirect();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const counter = useRef(0);
  const [sessionTopic, setSessionTopic] = useState('');
  const [sessionStartTime, setSessionStartTime] = useState('');
  const [sessionEndTime, setSsessionEndtTime] = useState('');

  const [vendorId, setVendorId] = useState('');
  const [sessionMeetingUrl, setSessionMeetingUrl] = useState('');

  const [userMessage, setUserMessage] = useState('Will begin in');
  const [isMeetingStarted, setIsMeetingStarted] = useState(false);

  const SESSION_BEGIN_TIME = 60 * 10;
  const { search, pathname } = useLocation();
  const { id } = queryString.parse(search);
  let myCounter;
  const handleSessionVendor = (vendorId, roomLink) => {
    console.log('session start handle ', vendorId);
    switch (vendorId) {
      case '0': //clirnet recorded session
       
        redirectTo('LiveSession', id, sessionTopic, 'from_waiting_room=1');
        break;
      case '2': //vouchpro
        if (roomLink) {
          openNewTab(roomLink);
        } else {
          toast.error('Room link not found! contact with admin');
        }
        break;
      case '4': //zoom
        if (roomLink) {
          openNewTab(roomLink);
        } else {
          toast.error('Room link not found! contact with admin');
        }
        break;
      case '5': //clirnet live
        
        redirectTo('LiveSession', id, sessionTopic, 'from_waiting_room=1');
        break;
      default:
        toast.error('Something wrong happen on session vendor.Contact With Host...');
        return false;
    }
  };
  const runServiceForLiveSession = (
    startTime,
    endTime,
    paramsVendorId,
    roomLink,
    sessionStatus
  ) => {
    counter.current = parseInt(counter.current) + 1;
    let startTimeDif = timeDifference(startTime);
    let endTimeDif = timeDifference(endTime);
    startTimeDif = Math.round(startTimeDif);
    endTimeDif = Math.round(endTimeDif);

    /////////////////////////running live condition-start/////////////////////////////////
    console.log('session start', counter.current, sessionStatus == 2, counter.current == 1);

    if (paramsVendorId && sessionStatus == 2 && counter.current == 1) {
      console.log('session start in if', paramsVendorId);

      setTimeout(() => {
        handleSessionVendor(paramsVendorId, roomLink);
      }, 10000);
      // if (myCounter) {
      //   myCounter.stop();
      // }
    } else if (paramsVendorId && sessionStatus == 2 && counter.current != 1) {
      console.log('session start in else if', paramsVendorId);

      handleSessionVendor(paramsVendorId, roomLink);
      // if (myCounter) {
      //   myCounter.stop();
      // }
    }

    if (startTimeDif >= 0 && endTimeDif <= 0) {
      setUserMessage('Please wait while the host lets you in...');
      setIsMeetingStarted(true);
      // if (paramsVendorId) {
      //   setTimeout(() => {
      //     handleSessionVendor(paramsVendorId, roomLink);
      //   }, 10000);
      // } else {
      //   toast.error('no vendor found. please contact with admin');
      // }
    } else {
    }
    /////////////////////////running live condition-end////////////////////////////////////

    /////////////////////////start live condition-start////////////////////////////////////
    if (startTimeDif && startTimeDif < 0) {
      myCounter = new TimeCounter({
        seconds: Math.abs(Math.ceil(startTimeDif)),
        onCounterEnd: function () {
          setUserMessage('Please wait while the host lets you in');
          setIsMeetingStarted(true);
          myCounter.stop();
        }
      });
      myCounter.start();
    } else {
      // utils.redirectToReservesession(props.history,sessionId)
    }

    /////////////////////////start live condition-end//////////////////////////////////////

    /////////////////////////end live condition-start/////////////////////////////////////
    if (endTimeDif && endTimeDif < 0) {
      myCounter = new TimeCounter({
        seconds: Math.abs(Math.ceil(endTimeDif)),
        onUpdateStatus: function (sec) {
          // console.log('live end in ' + sec + ' Sec');
        },
        onCounterEnd: function () {
          redirectTo('SessionDetails', id, sessionTopic);
          myCounter.stop();
        }
      });
      myCounter.start();
    } else {
      redirectTo('SessionDetails', id, sessionTopic);
    }

    /////////////////////////end live condition-end/////////////////////////////////////
  };

  useEffect(() => {
    generateTitle(pageName);
    generateDataLayerGtm(pageName);

    dispatch(
      getSessionDetail(id, (response) => {
        setLoader(false);
        if (response?.length > 0) {
          const { start_datetime, end_datetime, session_topic, vendor_id, room_link } = response[0];
          setSessionStartTime(start_datetime ?? '');
          setSsessionEndtTime(end_datetime ?? '');
          setSessionTopic(session_topic ?? '');
          setSessionMeetingUrl(room_link ?? '');
          setVendorId(vendor_id ?? '');

          // if (start_datetime && end_datetime) {
          //   runServiceForLiveSession(start_datetime, end_datetime, vendor_id, room_link);

          // }
        }
      })
    );
    // fetchRecentData()

    return () => {
      dispatch(ClearArray());

      if (myCounter) {
        myCounter.stop();
      }
    };
  }, []);
  useEffect(() => {
    if (sessionStartTime && sessionEndTime && pathname.toLowerCase() == '/sessionwaitingroom') {
      const sourceUrl = `${url}openapi/sse_session_status?session_id=${id}`;
      if (evtSource && evtSource?.readyState == 0) {
        console.log('event source effect called:', 'previous event source called');
        evtSource.close();
      }
      evtSource = new EventSource(sourceUrl);
      if (typeof EventSource !== 'undefined') {
        evtSource.onmessage = function (event) {
          if (pathname.toLowerCase() != '/sessionwaitingroom') {
            return false;
          }
          let tempResData = JSON.parse(event.data);


          runServiceForLiveSession(
            sessionStartTime,
            sessionEndTime,
            vendorId,
            sessionMeetingUrl,
            tempResData
          );
        };
      } else {
        console.log('sorry, your browser does not support server-sent events...');
        evtSource.close();
      }
    }

    return () => {
      if (evtSource) {
        // alert('evt closing');
        evtSource.close();
      }
    };
  }, [sessionStartTime, sessionEndTime, vendorId, sessionMeetingUrl, pathname]);

  return (
    <>
      <TrackerComponent page_name={pageName} page_id={id} module_page="session_waiting" />
      <div className="w-100 waiting_room">
        <div className="container">
          <div className="row justify-content-center align-items-center waiting_room_row min-vh-100 m-0 py-50">
            <div className="w-100 text-center">
              <div className="bannerWaitingRoom text-left text-md-center mb-0 mb-md-5">
                <div className="bannerWaitingRoomIn position-relative d-inline-block">
                  <BannerWorker page_name={'session_waiting_room'} />
                  <BannerItem position={'side-top'} page_name={'session_waiting_room'} />
                </div>
              </div>
              <h2 className="fw-semibold fs-1 text-white mt-0 mb-5 text-uppercase">
                Thank you for joining us!
              </h2>
              {sessionTopic && (
                <h3 className="text-white fs-2 fw-semibold mt-0 mb-4">{sessionTopic}</h3>
              )}
              <div className="clearfix"></div>
              {userMessage && <h4 className="fs-4 text-white">{userMessage}</h4>}
              {sessionStartTime && !isMeetingStarted && (
                <SessionWaitingTime date={sessionStartTime ? sessionStartTime : ''} />
              )}

              <div className="clearfix"></div>
            </div>
          </div>
          {/*END OF ROW */}
          <BackdropComponent backdrop={loader} />
        </div>
      </div>
    </>
  );
};

export default SessionWaitingRoom;
